<template>
  <DxPopup
    :visible="popupVisible"
    :drag-enabled="false"
    :hide-on-outside-click="true"
    :show-title="true"
    :width="'75%'"
    :height="650"
    title="Item Price Update"
    @hidden="popupHidden"
    :showCloseButton="false"
    :wrapperAttr="{ class: 'css-v2 gc-popup' }"
  >
    <div class="item-price-update-popup">
      <div class="price-update-header">
        <GcHeaderContentDynamic
          :viewMode="'popup'"
          :baseView="baseView"
          :primaryLabel="model.Description"
          :secondaryLabel="model.Code"
        />
      </div>
      <DxToolbar class="model-view-toolbar">
        <DxItem
          widget="dxForm"
          location="before"
          :options="{
            formData: model,
            items: toolbarBranchItems,
            validationGroup: 'toolbarBranchForm',
            labelLocation: 'left',
          }"
          locate-in-menu="auto"
          ref="so-toolbar-form"
        ></DxItem>
        <DxItem
          widget="dxForm"
          location="after"
          :options="{
            formData: model,
            items: toolbarActiveItems,
            validationGroup: 'toolbarForm',
            labelLocation: 'left',
            disabled: baseView.mode == 'review' ? true : false,
          }"
          locate-in-menu="auto"
          :disabled="baseView.mode == 'review' ? true : false"
        ></DxItem>
        <template #branchTemplate="{ data }">
          <div class="custom-auto-complete">
            <span class="auto-complete-primary">{{ data.Description }}</span>
            <span class="auto-complete-secondary">{{ data.Code }}</span>
          </div>
        </template>
      </DxToolbar>

      <div class="item-price-data-grid">
        <dx-data-grid
          :data-source="productReviewDataSourceConfig"
          :columns="productReviewColumns"
          :height="440"
          :allow-column-reordering="false"
          :column-chooser="{ enabled: false }"
        >
          <DxSearchPanel :visible="false" />
          <template #value-cell-template="{ data }">
            <div class="gc-editor-cell">
              <DxNumberBox
                :value="data.value"
                :format="data.column.format"
                class="gc-border-bottom-dotted"
                @value-changed="onGridValueChanged($event, data)"
                :min="0.0"
                :max="999999999.9999"
                :disabled="baseView.mode == 'review' ? true : false"
              />
            </div>
          </template>
          <template #price-group-cell-template="{ data }">
            <GcDescriptionCodeCellTemplate
              :description="data.data.Description"
              :code="''"
            />
          </template>
        </dx-data-grid>
      </div>

      <div class="footer item-price-update-popup-footer">
        <DxButton
          text="Save & Recalculate"
          type="default"
          styling-mode="contained"
          class="save-btn"
          @click="saveItemPriceUpdate('Y')"
        />
        <DxButton
          text="Save"
          type="default"
          styling-mode="contained"
          class="save-btn"
          @click="saveItemPriceUpdate('N')"
        />
        <DxButton
          text="Back"
          type="normal"
          styling-mode="contained"
          @click="popupHidden"
        />
      </div>
    </div>
  </DxPopup>
</template>

<script>
import { BranchService } from "../_services/api/sales/branch.service";
import { ItemPriceUpdateService } from "../_services/api/sales/item-price-update.service";
import BaseViewMixin from "../v1/_mixins/base.view";
import { DefaultCompanyBranchDivisionService } from "../_services/api/sales/default-company-branch-dicision.service";
import { CompanyService } from "../_services/api/accounts/company.service";
import LabelHelper from "../v1/_helpers/dev-express/label-helper";

export default {
  props: {
    setVisible: Boolean,
    callBack: {
      type: Function,
      default: function () {},
    },
    itemPriceUpdateData: Object,
    branchCode: String,
    setLoading: {
      type: Function,
      default: function () {},
    },
    // baseView: Object,
  },
  mixins: [BaseViewMixin],
  data() {
    return {
      BranchVisible: false,
      CellValueChanged: false,
      toolBarHeight: 0,
      model: {
        Code: null,
        Description: null,
        UpdateAll: true,
        BranchCode: undefined,
        BranchName: "",
        UpdateItemDataSource: [],
        CurrencyCode: "",
        ReturnValue: undefined,
      },
    };
  },
  async created() {
    this.$logger.debug("item data ", this.itemPriceUpdateData);
    this.$logger.debug(
      "item data BranchCode",
      this.itemPriceUpdateData.BranchCode
    );
    this.model.Code = this.itemPriceUpdateData.ItemCode;
    this.model.Description =
      this.itemPriceUpdateData.ItemDescription ||
      this.itemPriceUpdateData.Description;

    await this.getDefaults();
    // await this.$store.dispatch("screenFactors/getFactors", [65]);
    this.model.BranchCode = this.branchCode;
    this.$logger.debug("Branch Code ", this.model.BranchCode);
    this.getUpdateItemsDataList(this.model.Code);
  },
  computed: {
    productReviewColumns() {
      return this.parseGridColumns("master", [
        {
          gcLabel: "Price Group",
          dataField: "PriceGroupCode",
          cellTemplate: "price-group-cell-template",
          gcType: "String",
          gcSubType: "PrimaryRecord",
          gcExport: ["PriceGroupCode", "Description"],
        },

        {
          gcLabel: "Price Group",
          dataField: "PriceGroupCode",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenCode",
        },
        {
          gcLabel: "Description",
          dataField: "Description",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenDescription",
        },
        {
          gcLabel: "UM",
          dataField: "SalesUM",
          gcType: "String",
          width: 100,
          sortOrder: "asc",
        },

        {
          gcDynamicLabel: this.valueCaption,
          dataField: "PricingMethodValue",
          cellTemplate: "value-cell-template",

          gcType: "Decimal-4-4C",
          cssClass: "gc-editor-cell",
        },
      ]);
    },
    valueCaption() {
      return (
        LabelHelper.getLabelByName(`Price`) + ` (${this.model.CurrencyCode})`
      );
    },
    toolbarBranchItems() {
      var that = this;
      return [
        {
          dataField: this.BranchVisible ? "BranchCode" : null,
          editorType: "dxSelectBox",
          editorOptions: {
            dataSource: BranchService.dataSourceConfig("api/Branch", {
              // sort: [{ selector: "Description", asc: true }],
              select: ["Description", "Code"],
              filter: ["Inactive", "=", "N"],
            }),
            valueExpr: "Code",
            searchExpr: ["Code", "Description"],
            searchMode: "contains",
            showClearButton: false,
            itemTemplate: "branchTemplate",
            searchEnabled: true,
            displayExpr: "Description",
            acceptCustomValue: false,
            onSelectionChanged: (e) => {
              if (e.selectedItem)
                that.model.BranchName = e.selectedItem.Description;

              that.CellValueChanged = false;
            },
            onOpened: async (e) => {
              if (this.CellValueChanged) {
                let confirmLeaving = await this.$confirm(
                  "You have unsaved changes. Are you sure you want to change the branch?",
                  "Unsaved changes"
                );

                if (!confirmLeaving) {
                  e.component.close();
                }
              }
            },
            onValueChanged: (e) => {
              if (e.value == null) that.model.BranchCode = this.branchCode;
            },
            width: 200,
          },
          label: {
            text: "Branch",
            visible: false,
          },
        },
      ];
    },
    toolbarActiveItems() {
      return this.parseFormColumns([
        {
          dataField: "UpdateAll",
          gcType: "Boolean",
          gcLabel: "Update All Branches",
        },
      ]);
    },
    popupVisible() {
      return this.setVisible ? true : false;
    },
    productReviewDataSourceConfig() {
      return this.model.UpdateItemDataSource.filter((item) => {
        return this.model.BranchCode
          ? item.BranchCode == this.model.BranchCode
          : item;
      });
    },
  },
  watch: {
    setVisible: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      handler: function (newVal, oldVal) {
        if (newVal) {
          this.$logger.trackEventOpenPopup("Item Price Update");
        }
      },
    },
  },
  methods: {
    async saveItemPriceUpdate(Recalculate) {
      this.setLoading(true);
      var payload = {
        ProductCode: this.model.Code,
        BranchCode: this.model.BranchCode,
        AllBranches: this.model.UpdateAll ? "Y" : "N",
        Recalculate: Recalculate,
        ItemPriceDetails: (this.model.ReturnValue =
          this.model.UpdateItemDataSource.reduce((filtered, item) => {
            if (item.BranchCode == this.model.BranchCode) {
              var someNewValue = {
                PriceGroupCode: item.PriceGroupCode,
                PricingMethodValue: item.PricingMethodValue,
                SalesUM: item.SalesUM,
              };
              filtered.push(someNewValue);
              // if(item.Description == "Standard Sell"){
              //   this.model.ReturnValue = item.PricingMethodValue;
              // }
            }
            return filtered;
          }, [])),
      };

      this.$logger.trackEventButtonClick(
        `Item Price Update Popup Recalculate ${Recalculate}`,
        payload
      );

      await ItemPriceUpdateService.saveItemPrice(payload)
        .then((result) => {
          this.$logger.debug("saveItemPriceUpdate result ", result);

          this.CellValueChanged = false;

          this.setLoading(false);
          if (Recalculate == "Y") {
            this.$notify(
              `Prices for Item : ${this.model.Description} and Branch : ${
                this.model.UpdateAll ? "All Branches" : this.model.BranchName
              } have been updated.  Any open sales orders for the branch(es) that have this item have been recalculated.`,
              "success"
            );
            this.callBack(
              true,
              this.model.ReturnValue,
              this.itemPriceUpdateData
            );
          } else {
            this.$notify(
              `Prices for Item : ${this.model.Description} and Branch : ${
                this.model.UpdateAll ? "All Branches" : this.model.BranchName
              } have been updated.`,
              "success"
            );
            this.callBack(false, null);
          }
        })
        .catch((error) => {
          this.$logger.debug("saveItemPriceUpdate error ", error);
          this.setLoading(false);
        });
    },
    async onGridValueChanged(valueChangedEventArg, cellInfo) {
      cellInfo.value = valueChangedEventArg.value;
      cellInfo.data.PricingMethodValue = valueChangedEventArg.value;
      this.CellValueChanged = true;
    },
    async getUpdateItemsDataList(Code) {
      await ItemPriceUpdateService.getDataByCode({
        url: "api/ItemPrice",
        select: [
          "PriceGroupCode",
          "Description",
          "SalesUM",
          "BranchCode",
          "PricingMethodValue",
          "ProductCode",
        ],
        sort: [
          { selector: "PriceGroupCode", asc: true },
          { selector: "SalesUM", asc: true },
        ],
        filter: `ProductCode eq '${Code}'`,
      }).then((result) => {
        this.$logger.debug("getUpdateItemsDataList ", result);
        this.model.UpdateItemDataSource = result.data.value;
        this.$logger.debug(
          "getUpdateItemsDataList ",
          this.model.UpdateItemDataSource
        );
      });
      this.BranchVisible = true;
    },
    async getDefaults() {
      await DefaultCompanyBranchDivisionService.getDefault().then(
        async (result) => {
          if (result.data.value.length > 0) {
            await CompanyService.getByCompanyCode(
              result.data.value[0].CompanyCode
            ).then((res) => {
              this.model.CurrencyCode = res.data.value[0].CurrencyCode;
            });
          }
        }
      );
    },
    popupHidden() {
      this.callBack(false);
    },
  },
};
</script>

<style lang="scss">
.price-update-header {
  padding-bottom: 24px;
  // margin-left: -24px;
  // margin-right: -24px;
  border-bottom: 1px solid #e0e0e0;
  .text-primary {
    margin-left: 24px !important;
  }
}

.item-price-update-popup-footer {
  // .footer {
  padding: 0px !important;
  bottom: 0;
  height: 45px;
  text-align: right;
  // }

  .save-btn {
    margin-right: 10px;
  }
}

.css-v2.gc-popup {
  .dx-popup-content {
    .price-update-header {
      background-color: white;
      padding: 15px;
    }
  }
}

.item-price-update-popup {
  padding: 10px;
  .price-update-header {
    margin-bottom: 10px;
    border-radius: 3px;
    .text-primary {
      margin: 0 !important;
    }
  }

  .model-view-toolbar.dx-toolbar {
    border-radius: 3px 3px 0 0;
    .dx-toolbar-before {
      padding-left: 10px;
    }

    .dx-toolbar-after {
      padding-right: 10px;
    }

    .dx-layout-manager .dx-field-item {
      padding: 0;
    }
  }

  .item-price-data-grid {
    padding-bottom: 10px;
    .dx-widget.dx-card {
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
    .dx-datagrid {
      .dx-datagrid-headers {
        height: 40px;

        .dx-datagrid-content {
          height: inherit;
          .dx-datagrid-table {
            height: inherit;
          }
        }
      }

      .dx-datagrid-headers .dx-header-row {
        td {
          padding-top: 10px;
          padding-bottom: 10px;
          padding-left: 5px;
          padding-right: 5px;
        }
      }

      .dx-datagrid-rowsview .dx-data-row {
        td {
          font-size: 12px;
          padding-top: 2px !important;
          padding-bottom: 2px !important;

          .dx-button.dx-button-has-icon {
            width: 30px;
            min-width: 30px;
            // height: 30px;
            .dx-button-content {
              padding: 3px;
            }
            .dx-icon {
              font-size: 18px;
              margin-right: 0px;
              padding: 0px;
            }
          }
        }

        .dx-editor-cell {
          input {
            font-size: 12px;
            height: 20px !important;
          }
        }
      }
    }
  }
}
</style>
